module.exports = __webpack_public_path__ + "img/NL.ac70f70c.svg";